import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsDomalisa(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsDomalisa(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsDomalisa - ', e);
                throw e;
            });
    };
}
export { getLogsDomalisa };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsDomalisa/actions.js